'use client';

import { c as _c } from "react/compiler-runtime";
import type { InitiativeDemographics } from '@sizzlenz/shared';
import { DEMOGRAPHICS_AGE_GROUP_OPTIONS, DEMOGRAPHICS_GENDER_MIX_OPTIONS } from '@sizzlenz/shared';
import { Users } from 'lucide-react';
interface DemographicsSummaryProps {
  demographics: InitiativeDemographics;
}
export function DemographicsSummary(t0) {
  const $ = _c(33);
  const {
    demographics
  } = t0;
  const {
    numberOfAttendees,
    ageGroups,
    gender,
    genderSplit
  } = demographics;
  let t1;
  if ($[0] !== gender) {
    t1 = DEMOGRAPHICS_GENDER_MIX_OPTIONS.find(o => o.id === gender)?.label;
    $[0] = gender;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const genderMixLabel = t1;
  let femaleWidth;
  let maleWidth;
  let otherWidth;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== ageGroups || $[3] !== genderSplit?.female || $[4] !== genderSplit?.male || $[5] !== genderSplit?.other || $[6] !== numberOfAttendees) {
    const ageGroupLabels = ageGroups.map(_temp).filter(Boolean).sort(_temp2).map(_temp3);
    maleWidth = genderSplit?.male ?? 0;
    femaleWidth = genderSplit?.female ?? 0;
    otherWidth = genderSplit?.other ?? 0;
    t5 = "space-y-2";
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider flex items-center gap-2">Attendees</h3>;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    t2 = "space-y-3 text-sm";
    if ($[16] !== numberOfAttendees) {
      t3 = numberOfAttendees != null && <div className="flex items-center justify-between"><span className="text-gray-600">Approximate # of attendees</span><span className="font-medium text-gray-900">{numberOfAttendees}</span></div>;
      $[16] = numberOfAttendees;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    t4 = ageGroupLabels.length > 0 && <div><span className="text-gray-600 text-xs">Age Groups</span><div className="flex flex-wrap gap-1.5 mt-1">{ageGroupLabels.map(_temp4)}</div></div>;
    $[2] = ageGroups;
    $[3] = genderSplit?.female;
    $[4] = genderSplit?.male;
    $[5] = genderSplit?.other;
    $[6] = numberOfAttendees;
    $[7] = femaleWidth;
    $[8] = maleWidth;
    $[9] = otherWidth;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    femaleWidth = $[7];
    maleWidth = $[8];
    otherWidth = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
  }
  let t7;
  if ($[18] !== femaleWidth || $[19] !== gender || $[20] !== genderMixLabel || $[21] !== maleWidth || $[22] !== otherWidth) {
    t7 = gender && <div className="space-y-2 border-t border-gray-200 pt-3"><div className="flex items-center justify-between"><span className="text-gray-600">Gender</span><span className="font-medium text-gray-900">{genderMixLabel}</span></div>{gender && (maleWidth > 0 || femaleWidth > 0 || otherWidth > 0) && <div className="space-y-1"><span className="text-gray-600 text-xs">Split</span><div className="w-full h-6 rounded-md overflow-hidden flex text-[10px] font-medium text-white">{maleWidth > 0 && <div className="h-full bg-slate-800 flex items-center justify-center" style={{
            width: `${maleWidth}%`
          }}>{maleWidth >= 12 && `M ${maleWidth}%`}</div>}{femaleWidth > 0 && <div className="h-full bg-slate-500 flex items-center justify-center" style={{
            width: `${femaleWidth}%`
          }}>{femaleWidth >= 12 && `F ${femaleWidth}%`}</div>}{otherWidth > 0 && <div className="h-full bg-slate-300 flex items-center justify-center text-slate-700" style={{
            width: `${otherWidth}%`
          }}>{otherWidth >= 12 && `${otherWidth}%`}</div>}</div></div>}</div>;
    $[18] = femaleWidth;
    $[19] = gender;
    $[20] = genderMixLabel;
    $[21] = maleWidth;
    $[22] = otherWidth;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t2 || $[25] !== t3 || $[26] !== t4 || $[27] !== t7) {
    t8 = <div className={t2}>{t3}{t4}{t7}</div>;
    $[24] = t2;
    $[25] = t3;
    $[26] = t4;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t5 || $[30] !== t6 || $[31] !== t8) {
    t9 = <div className={t5}>{t6}{t8}</div>;
    $[29] = t5;
    $[30] = t6;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  return t9;
}
function _temp4(label) {
  return <span key={label} className="bg-white border border-gray-200 text-gray-700 text-[11px] px-2 py-0.5 rounded-md">{label}</span>;
}
function _temp3(item) {
  return item.label;
}
function _temp2(a, b) {
  return a.minAge - b.minAge;
}
function _temp(key) {
  const option = DEMOGRAPHICS_AGE_GROUP_OPTIONS.find(o_0 => o_0.id === key);
  if (!option) {
    return null;
  }
  const minAge = parseInt(option.id, 10) || (option.id === "80+" ? 80 : 0);
  return {
    label: option.label,
    minAge
  };
}